import { Injectable } from '@angular/core';
import { addDays, addHours, isAfter } from 'date-fns';
import { BehaviorSubject } from 'rxjs';
import { TennisOneLocalStore, Timeline } from '../_interfaces';
import { SsrlocalstoreService } from './ssr-localstore.service';
import { v4 } from 'uuid';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {
    private defaults: TennisOneLocalStore = {
        user: {
            fan_id: '',
            fingerprint: this.ssr.getItem('golfOne-fingerprint') || `web-${v4()}`,
            token: null,
            ttl: this.generateTTL()
        },
        timeline_hub: {
            cache: [],
            ttl: addHours(new Date(), 1).getTime()
        }
    }
    public store: BehaviorSubject<TennisOneLocalStore> = new BehaviorSubject<TennisOneLocalStore>(this.defaults);

    constructor(
        private ssr: SsrlocalstoreService
    ) {
        this.store.next(JSON.parse(this.ssr.getItem('golfOne') as string));
    }

    private generateTTL(): number {
        return addDays(new Date, 5).getTime();
    }

    async initLocalStore() {
        try {
            this.ssr.getItem('golfOne') ? null : this.ssr.setItem('golfOne', JSON.stringify(this.defaults));

            this.store.next(JSON.parse(this.ssr.getItem('golfOne') as string));
            return
        } catch (err) {
            throw err
        }
    }

    getLocalStoreCache(): Timeline[] {
        if (this.ssr.isClientSide) {
            return this.store.value.timeline_hub.cache;
        }

        return []
    }

    getLocalStore(): TennisOneLocalStore {
        return this.ssr.getItem('golfOne') ? JSON.parse(this.ssr.getItem('golfOne') as string) : {} as TennisOneLocalStore;
    }

    setLocalStore(new_store: TennisOneLocalStore) {
        return this.ssr.setItem('golfOne', JSON.stringify(new_store));
    }

    timelineCacheExpired(): boolean {
        if (this.ssr.getItem('golfOne')) {
            const locale_cache: TennisOneLocalStore = JSON.parse(this.ssr.getItem('golfOne') as string)

            if (isAfter(new Date(), new Date(locale_cache.timeline_hub.ttl))) {
                return true;
            }
        }
        return false;
    }

    setTimelineCache(timeline_data: Timeline[]) {
        const current_cache = this.store.value;

        current_cache.timeline_hub.cache = timeline_data;
        current_cache.timeline_hub.ttl = addHours(new Date(), 1).getTime();

        this.store.next(current_cache)
        this.ssr.setItem('golfOne', JSON.stringify(current_cache))

    }

    updateUserProperty(key: string, value: string): void {
        const data = JSON.parse(this.ssr?.getItem?.('golfOne') ?? '');
        if (data?.user) {
            data.user[key] = value;
            this.setLocalStore(data);
        };
    }

    clear(): void {
        const local_keys = Object.keys(localStorage);
        if (local_keys) {
            local_keys.forEach((key) => {
                if (key !== 'preferredLanguage' && key !== 'whatsNewContentURL') {
                    this.ssr?.removeItem(key)
                }
            })
        }
    }
}
